<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import api from "./api";
import appConfig from "@/app.config";

export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  mounted() {
    this.loadRoles();
  },
  methods: {
    async loadRoles() {
      const response = await api.get("/api/roles/");
      if (response.data) {
        this.$store.commit("updateRoles", response.data);
      }
    },
  },
};
</script>
